import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import profileUserService from './user_profile-service';

export const UserGetProfile = createAsyncThunk(
  'user_profile/user_getProfile',
  async (_, thunkAPI) => {
    try {
      const delivered = await profileUserService.userGetProfile();

      return delivered;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const EditUserProfile = createAsyncThunk(
  'user_profile/edit_profile_user',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await profileUserService.editUser(requestData);

      return delivered;
    } catch (e) {
      toast(e?.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const EditUserDetails = createAsyncThunk(
  'user_profile/edit_profile_Details',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await profileUserService.editUserDetails(requestData);

      return delivered;
    } catch (e) {
      toast(e?.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const EditUserAddress = createAsyncThunk(
  'user_profile/edit_profile_Address',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await profileUserService.editUserAddress(requestData);

      return delivered;
    } catch (e) {
      toast(e?.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const EditUserPassword = createAsyncThunk(
  'user_profile/edit_user_password',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await profileUserService.editUserPassword(requestData);

      return delivered;
    } catch (e) {
      toast(e?.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);
